import { StringExt } from '../string';
export function getData(dataset, name) {
    const value = dataset[name] || dataset[StringExt.camelCase(name)];
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return value;
    }
}
export function setData(dataset, name, value) {
    let val = value;
    try {
        val = JSON.stringify(val);
    }
    catch (e) {
        // paas
    }
    dataset[StringExt.camelCase(name)] = val;
}
export function data(elem, name, value) {
    if (!name) {
        const datas = {};
        const dataset = elem.dataset;
        // eslint-disable-next-line
        for (const key in dataset) {
            datas[key] = getData(dataset, key);
        }
        return datas;
    }
    if (typeof name === 'string') {
        const dataset = elem.dataset;
        if (value === undefined) {
            return getData(dataset, name);
        }
        setData(dataset, name, value);
        return;
    }
    // eslint-disable-next-line
    for (const key in name) {
        data(elem, key, name[key]);
    }
}
//# sourceMappingURL=data.js.map